/* eslint-disable */
export default {
  Inbound: 'Entrante',
  Outbound: 'Saliente',
  log: 'Registro',
  save: 'Guardar y abrir nuevo',
  discard: 'Desechar y abrir nuevo',
  hangup: 'Colgar',
  reject: 'Enviar al buzón de voz',
  saveDraftAndCreateNewLog:
    'Guardar borrador y crear un nuevo registro de llamadas',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
